import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=073caba7&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
import style0 from "./Video.vue?vue&type=style&index=0&id=073caba7&prod&lang=scss&scoped=true"
import style1 from "./Video.vue?vue&type=style&index=1&id=073caba7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073caba7",
  null
  
)

export default component.exports